import { CustomErrorType } from "../interfaces/CustomErrorType";

export default {
    code: 'ERR_DUPLICATED_ENTRIES',
    statusCode: 400,
    message: {
        en: 'Duplicated Entries',
    },
} as CustomErrorType;